<!-- 设备履历 -->
<style scoped="scoped" lang="scss"></style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mould/resume/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldIds"> </yi_cross_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button  size="mini"
          @click="yt.showEditDialog('web_mold_management_resume_yognxin_updateTempTotalCloseTimes', null, 'w1');setDefaultValue();  "   type="primary"  :disabled="!single">   {{ $t('xiugai') }}  </el-button>

      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!-- <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="yt.exportExcel()">
			</el-button> -->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('baoyangxiang', scope.row, '70%')">
              {{ $t('baoyangxiang') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }} </el-button>
            <el-button v-if="scope.row.status == 1" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/equipment/maintain/bill/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 处理无接入时间为0的设备 -->
      <template #jierushijian="scope">
        {{ scope.row.installTime != null ? time(scope.row.installTime) : '' }}
      </template>
      <!-- 冻结列 点检次数 -->
      <template #dianjiancishu="scope">
        <el-button type="text" @click="yt.showEditDialog('dianjiancishu', scope.row, '70%')">
          {{ scope.row.checkTimes }}
        </el-button>
      </template>
      <!-- 冻结列 保养次数 -->
      <template #baoyangcishu="scope">
        <el-button type="text" @click="yt.showEditDialog('baoyangcishu', scope.row, '70%')">
          {{ scope.row.maintainTimes }}
        </el-button>
      </template>
      <!-- 冻结列 维修次数 -->
      <template #weixiucishu="scope">
        <el-button type="text" @click="yt.showEditDialog('weixiucishu', scope.row, '70%')">
          {{ scope.row.repairTimes }}
        </el-button>
      </template>
      <!-- 模具距离下次保养次数 -->
      <template #julibaoyangshengyushotshu="scope">
        <span :style="{color: scope.row.distanceNextMaintenanceTimes < 0? 'red':null}">
          {{ scope.row.distanceNextMaintenanceTimes }}
        </span>
      </template>
      <template #leijitongdianshijian(xiaoshi)="scope">
        {{ scope.row.onlineTime.toFixed(0) }}
      </template>
      <template #leijiyunxingshijian(xiaoshi)="scope">
        {{ scope.row.runTime.toFixed(0) }}
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增弹窗 -->
      <template v-if="yt.editObj.action == 'web_mold_management_resume_yognxin_updateTempTotalCloseTimes'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('mujushotshu')">
            <el-input-number v-model="yt.editObj.totalClosingTimes"  :precision="0"/>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/mould/resume/updateTempTotalCloseTimes')" type="primary">
            {{ $t('baocun') }}
          </el-button>
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
        </span>
      </template>
    </el-dialog>


  </div>
</template>
<script type="text/javascript">
// import check_record from '@@/pages/web/equipment/resume/check_record'
import maintenance_times from './maintenance_times';
import repair_times from './repair_times';
export default {
  name: 'web_mold_management_resume_list_yongxin',
  components: {
    maintenance_times,
    repair_times
  },

  data() {
    return {
      // orgList: [],
      list: [],
      single: false,
      ids:[],
      columns: [
        {
          label: 'xuanze',
          type: 'selection'
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no',
          fixed: 'left'
        },
        {
          label: 'mujubianma',
          prop: 'mould.code'
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name',
          fixed: 'left'
        },
        {
          label: 'mujuzhuangtai',
          prop: 'mould.status',
          type: 'dictionary_tag',
          key: 'BASIC_MOULD_STATUS'
        },
        {
          label: "mujuweizhi",
          prop: "mould.location"
        },
        {
          label: 'mujulurushijian',
          prop: 'insertTime',
          type: 'time'
        },
        {
          label: 'mujushouming',
          prop: 'life'
        },
        {
          label: 'earlyUsedLifetime',
          prop: 'earlyUsedLifetime',
        },
        {
          label: 'mujushotshu',
          prop: 'tempTotalClosingTimes',
        },
        {
          label: 'mujushengyushouming',
          prop: 'tempRemainingLife'
        },
        {
          label: 'shangcibaoyangshijian',
          prop: 'lastMaintainTime',
          type: 'time'
          // format: "YYYY-MM-DD"
        },
        {
          label: 'julibaoyangshengyushotshu',
          type: 'slot',
        },
        {
          label: 'baoyangcishu',
          type: 'slot',
          width: 80,
          fixed: 'right'
        },
        {
          label: 'weixiucishu',
          type: 'slot',
          width: 80,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.utils.event_hub.$on('MOLD_RESUME_MAINTENANCE_REFRESH', () => {
        this.yt.get();
      });
      this.yt.conditions = {
        orderBy: 'no asc'
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    setDefaultValue(){
      this.yt.editObj.id = this.ids[0];
    },
    selectionChange(items) {
      this.ids = items.map(item => {
        return item.id;
      });
      if (this.ids.length == 1) {
        this.single = true;
      } else  {
        this.single = false;
      }
    },
    time(e) {
      if (e == 0) {
        return '';
      }
      let date = new Date(e);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      let d = date.getDate();
      d = d < 10 ? '0' + d : d;
      let h = date.getHours();
      h = h < 10 ? '0' + h : h;
      let m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      let s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    }
    // /* 获取组织架构列表 */
    // async getOrgList() {
    // 	let response = await this.http.get('/web/setting/org/page', {
    // 		params: {
    // 			pageSize: 99999,
    // 		}
    // 	})
    // 	this.orgList = response.data.rows
    // },
  }
};
</script>
